import { useEffect, useState } from 'react';
import { useFormikContext, Field } from 'formik';

import { InputUI, TabsUI, FormLabelUI, FormErrorUI } from '../../Interface';
import DynamicPropertyMain from '../../DynamicProperty/DynamicPropertyMain';
import jokerService from '../../../service/joker.service';
import { JokerTypes } from '../../../config/joker';
import JokerTab from '../../Interface/Joker/JokerTab';

const DescriptionPanel = (props) => {
  const { disabled } = props;
  const { values, errors } = useFormikContext();
  return (
    <div className="col-span-full relative">
      <div>
        <Field
          type="text"
          name="description"
          as={InputUI}
          className={`${disabled ? 'rounded-md' : ''} resize-none h-36, p-2`}
          fullWidth
          label={<FormLabelUI text="Leírás" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.description} />}
          disabled={disabled}
          InputLabelProps={{ shrink: values.description !== '' }}
          multiline
          rows={4}
        />
      </div>
    </div>
  );
};

const ComplaintCoreTabs = (props) => {
  const [activeTab, setActiveTab] = useState(0);
  const [jokerGroups, setJokerGroups] = useState([]);

  const getJokerGroups = async () => {
    jokerService.getGroups(JokerTypes.COMPLAINT).then((data) => {
      setJokerGroups(data);
    });
  };

  useEffect(() => {
    getJokerGroups();
  }, []);

  const tabs = [
    ...((jokerGroups.length > 0 &&
      jokerGroups
        .filter((group) => group.jokerFields.length > 0)
        .map((group, index) => ({
          id: index,
          name: group.name,
          content: <JokerTab fields={group.jokerFields} key={index} {...props} />,
        }))) ||
      []),
    {
      id: jokerGroups.length,
      name: 'Tulajdonságok',
      content: <DynamicPropertyMain {...props} />,
    },
    {
      id: jokerGroups.length + 1,
      name: 'Leírás',
      content: <DescriptionPanel {...props} />,
    },
  ];

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div className="my-4 mt-6">
      <div className="px-3">
        <TabsUI activeTab={activeTab} handleTabClick={handleTabClick}>
          {tabs.map((tab, index) => (
            <div key={index} name={tab.name}>
              {tab.content}
            </div>
          ))}
        </TabsUI>
      </div>
    </div>
  );
};

export default ComplaintCoreTabs;
